import { Combobox } from './Combobox';

export type { TypeComboboxProps } from './types';
export default Combobox;
